import { render, staticRenderFns } from "./EightByFour.vue?vue&type=template&id=0574d186&scoped=true"
import script from "./EightByFour.vue?vue&type=script&lang=js"
export * from "./EightByFour.vue?vue&type=script&lang=js"
import style0 from "./EightByFour.vue?vue&type=style&index=0&id=0574d186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574d186",
  null
  
)

export default component.exports